module.exports = "/_next/static/images/iconfont-b2619691854094396c0829756da3e14c.svg";